<template>
  <v-dialog
    persistent v-model="modal" lazy>
    <v-text-field
      slot="activator"
      @focus="modal = true"
      :label="config.label"
      :value="dateFormatter(value)"
      :required="config.required"
      :error="haveErrors()"
      :rules="config.errors"
      readonly>
    </v-text-field>
    <v-date-picker
      :value="value"
      @input="value => emit(value)"
      :date-format="dateFormatter"
      :formatted-value="dateFormatter"
      scrollable>
      <template scope="{ cancel }">
        <v-card-row actions>
          <v-btn flat primary @click.native="clear()">{{ $t('inputs.date.clear') }}</v-btn>
          <v-btn flat primary @click.native="cancel()">{{ $t('inputs.date.cancel') }}</v-btn>
        </v-card-row>
      </template>
    </v-date-picker>
  </v-dialog>
</template>

<script>
  import input from '@/mixins/input'
  export default {
    mixins: [input],
    data () {
      return {
        modal: false
      }
    },
    methods: {
      dateFormatter (value) {
        return value ? this.$d(new Date(value), 'short') : null
      },
      clear () {
        this.emit(null)
        this.modal = false
      }
    }
  }
</script>

<style lang="stylus">
  @import "../../variables"

  .dialog__container {
    width: 100%;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/inputs/Date.vue